(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-meter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-code-meter')) {
    let cartCodes = [];

    customElements.define(
      'cart-code-meter',
      class CartCodeMeter extends HTMLElement {
        connectedCallback() {
          this.showMeter();
          fetch(`${window.routes.cart_url}.js`)
            .then((response) => response.json())
            .then((cart) => {
              cartCodes = cart.discount_codes.map(({ code }) => code.toUpperCase());
              this.showMeter();
            })
            .catch(() => {});
        }

        showMeter() {
          const hasCode = cartCodes.includes(this.dataset.code);
          this.querySelectorAll('.cart-meter').forEach((meter) => {
            meter.hidden = hasCode !== meter.hasAttribute('data-needs-code');
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promotion-run"] && !Shopify.designMode) return;
  try {
    (() => {
    const showDuringPromotion = () => {
      const now = Date.now();
      document.querySelectorAll('[data-promotion-starts]').forEach((element) => {
        element.hidden = now < Number(element.dataset.promotionStarts) || now >= Number(element.dataset.promotionEnds);
      });
    };

    showDuringPromotion();
    setInterval(showDuringPromotion, 30000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promotion-text"] && !Shopify.designMode) return;
  try {
    (() => {
    const showLivePromotions = () => {
      const now = Date.now();
      document.querySelectorAll('[data-promotion-slot]').forEach((slot) => {
        const entries = [...slot.querySelectorAll('[data-starts]')];
        const live = entries
          .filter((entry) => Number(entry.dataset.starts) <= now && now < Number(entry.dataset.ends || Infinity))
          .sort((a, b) => Number(b.dataset.starts) - Number(a.dataset.starts))[0];
        entries.forEach((entry) => {
          entry.hidden = entry !== live;
        });
        const fallback = slot.querySelector('[data-promotion-default]');
        if (fallback) fallback.hidden = Boolean(live);
        const shown = live || fallback;
        slot.hidden = !shown || shown.textContent.trim() === '';
      });
    };

    showLivePromotions();
    setInterval(showLivePromotions, 60000);
  })();
  } catch(e) { console.error(e); }
})();

})();
